var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcceptOrderOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#04B7B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21521_175593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21521_175593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 22L18.85 20.6L20.425 19H16.25V17H20.425L18.85 15.4L20.25 14L24.25 18L20.25 22ZM11 16C11.9333 16 12.775 15.7708 13.525 15.3125C14.275 14.8542 14.8667 14.25 15.3 13.5C14.7167 13.0167 14.0583 12.6458 13.325 12.3875C12.5917 12.1292 11.8167 12 11 12C10.1833 12 9.40833 12.1292 8.675 12.3875C7.94167 12.6458 7.28333 13.0167 6.7 13.5C7.13333 14.25 7.725 14.8542 8.475 15.3125C9.225 15.7708 10.0667 16 11 16ZM11 11C11.55 11 12.0208 10.8042 12.4125 10.4125C12.8042 10.0208 13 9.55 13 9C13 8.45 12.8042 7.97917 12.4125 7.5875C12.0208 7.19583 11.55 7 11 7C10.45 7 9.97917 7.19583 9.5875 7.5875C9.19583 7.97917 9 8.45 9 9C9 9.55 9.19583 10.0208 9.5875 10.4125C9.97917 10.8042 10.45 11 11 11ZM11 23C8.31667 20.7167 6.3125 18.5958 4.9875 16.6375C3.6625 14.6792 3 12.8667 3 11.2C3 8.7 3.80417 6.70833 5.4125 5.225C7.02083 3.74167 8.88333 3 11 3C13.1167 3 14.9792 3.74167 16.5875 5.225C18.1958 6.70833 19 8.7 19 11.2C19 11.35 18.9958 11.5042 18.9875 11.6625C18.9792 11.8208 18.9583 11.9833 18.925 12.15H16.9C16.9333 11.9833 16.9583 11.8208 16.975 11.6625C16.9917 11.5042 17 11.35 17 11.2C17 9.38333 16.4208 7.89583 15.2625 6.7375C14.1042 5.57917 12.6833 5 11 5C9.31667 5 7.89583 5.57917 6.7375 6.7375C5.57917 7.89583 5 9.38333 5 11.2C5 12.3833 5.49167 13.7375 6.475 15.2625C7.45833 16.7875 8.96667 18.4833 11 20.35C11.3833 20.0167 11.7375 19.6833 12.0625 19.35C12.3875 19.0167 12.7 18.6917 13 18.375L13.7125 19.0875C13.8875 19.2625 14.0458 19.425 14.1875 19.575L14.4 19.8C13.9167 20.3167 13.3917 20.8417 12.825 21.375C12.2583 21.9083 11.65 22.45 11 23Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptOrderOn);
export default __webpack_public_path__ + "static/media/AcceptOrderOn.f0306063de3a61cdf88a177b15271618.svg";
export { ForwardRef as ReactComponent };